import { useEffect, useState } from 'react'
import i18next from 'i18next'

const calculateText = (days: number, hours: number, minutes: number) => {
    if (days > 0) {
        return i18next.t('txt_days')
    } else if (hours > 0) {
        return i18next.t('txt_hours')
    } else if (minutes > 0) {
        return i18next.t('txt_minutes')
    } else {
        return i18next.t('txt_sec')
    }
}
const useCountdown = (targetDate: Date) => {
    const countDownDate = new Date(targetDate).getTime()
    const [countDown, setCountDown] = useState(
        countDownDate - new Date().getTime()
    )

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown(countDownDate - new Date().getTime())
        }, 1000)

        return () => clearInterval(interval)
    }, [countDownDate])

    return getReturnValues(countDown)
}

export const formattedTime = (text?: string | number) =>
    `${String(text)?.padStart(2, '0')}`

const getReturnValues = (countDown: number) => {
    // calculate time left
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24))

    const hours = Math.floor(
        (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

    const timerLabel = calculateText(days, hours, minutes)
    return {
        time: [days, hours, minutes, seconds],
        timerLabel,
    }
}

export { useCountdown }
